module.exports = __webpack_public_path__ + "static/dragon-32c73ad4dc628f31f673392fd28419e0.jpg";